
class TicketFilter {
	productUuids = null;
	assigneeUuids = null;
	stateSignets = null;
}


export { TicketFilter };
